import(/* webpackMode: "eager" */ "/vercel/path1/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/components/admin/SidebarNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/components/auth/NavbarClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationProvider"] */ "/vercel/path1/components/NotificationProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path1/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
